import React from 'react';
import { useSelector } from 'react-redux';

import { Form, Select, DatePicker } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';
import { formatDate } from 'utilities/common';

import _ from 'underscore';

const typeOptions = [
  {value: 'On Demand', label: 'On Demand'},
  {value: 'Project', label: 'Project'},
  {value: 'Routine', label: 'Routine'}
]

const methodOptions = [
  {value: 'Direct', label: 'Direct'},
  {value: 'Monthly', label: 'Monthly'},
  {value: 'Weekly', label: 'Weekly'}
]

const topOptions = [
  { value: 7, label: '7 Hari' },
  { value: 14, label: '14 Hari' },
  { value: 21, label: '21 Hari' },
  { value: 30, label: '30 Hari' },
  { value: 45, label: '45 Hari' },
];

const initialState = {
  customer: null,
  quotation: null,
  name: '',
  typeSelected: null,
  invoiceMethod: null,
  start: {
    default: new Date(),
    formatted: formatDate(new Date(), 'YYYY-MM'),
  },
  end: null,
  is_pkp: false,
  ppn: 0,
  pph: 0,
  termOfPayment: null,
};

export const FormInput = ({ data, loading, onInputChange }) => {
  const StateForm = useSelector((state) => state?.Form);

  const [
    { customer, quotation, name, typeSelected, invoiceMethod, start, end, is_pkp, ppn, pph, termOfPayment },
    setState,
  ] = React.useState(initialState);

  const dummy = Array.from({ length: 4 }, (v, i) => i);

  React.useEffect(() => {
    const input = {
      customer_id: customer?.id,
      quotation_id: quotation?.id,
      name,
      type: typeSelected?.value,
      invoice_method: invoiceMethod?.value,
      start_monthly: start?.formatted,
      end_monthly: end?.formatted,
      is_pkp,
      ppn,
      pph,
      top: termOfPayment?.value
    };

    if (input?.end_monthly === 'Invalid date') {
      input.end_monthly = ''
    }

    onInputChange(input);
  }, [customer, quotation, name, typeSelected, invoiceMethod, start, end, is_pkp, ppn, pph, termOfPayment]);

  React.useEffect(() => {
    if (!data) return;

    let t = null
    let im = null
    let top = null

    _.each(typeOptions, (i) => {
      if (i?.value === data?.type) {
        t = i
      }
    })

    _.each(methodOptions, (i) => {
      if (i?.value === data?.invoice_method) {
        im = i
      }
    })

    _.each(topOptions, (i) => {
      if (i?.value === data?.top) {
        top = i
      }
    })

    let em = null
    if (data?.end_monthly !== '0001-01-01T00:00:00Z') {
      em = {
        default: new Date(data?.end_monthly),
        formatted: formatDate(data?.end_monthly, 'YYYY-MM'),
      }
    }

    setState((prevState) => ({
      ...prevState,
      customer: data?.customer,
      quotation: data?.quotation,
      name: data?.name,
      typeSelected: t,
      invoiceMethod: im,
      start: {
        default: new Date(data?.start_monthly),
        formatted: formatDate(data?.start_monthly, 'YYYY-MM'),
      },
      end: em,
      is_pkp: data?.is_pkp,
      ppn: data?.ppn,
      pph: data?.pph,
      termOfPayment: top
    }));
  }, [data]);

  const $handleStart = async (e) => {
    setState((prevState) => ({
      ...prevState,
      start: { default: e, formatted: formatDate(e, 'YYYY-MM') },
    }));
  };

  const $handleEnd = async (e) => {
    setState((prevState) => ({
      ...prevState,
      end: { default: e, formatted: formatDate(e, 'YYYY-MM') },
    }));
  };

  return (
    <div className="mt-3">
      {loading ? (
        <div className="row border-bottom">
          {dummy?.map((d, i) => (
            <div className="col-md-4" key={i}>
              <SkeletonsForm count={1} />
            </div>
          ))}
        </div>
      ) : (
        <div className="mt-3">
          <div className="row">
            <div className="col-md-6 border-end pe-md-4 pe-0">
              <div className="mb-3">
                <Select.Remote
                  required
                  label="Pilih Customer"
                  placeholder=""
                  url="/partner"
                  params={{'type': 'customer', 'search': customer ? customer?.name: ''}}
                  initialValue={customer?.id}
                  keys={customer?.id}
                  row={(d) => {
                    return { value: d.id, label: d.name };
                  }}
                  onSelected={(c) => {
                    setState((prevState) => ({
                      ...prevState,
                      customer: c,
                    }))
                  }}
                  errors={StateForm?.errors?.customer_id}
                />
              </div>
              {customer && (
                <div className="mb-3">
                  <Select.Remote
                    required
                    label="Pilih Quotation"
                    placeholder=""
                    url="/marketing/quotation"
                    params={{'status': 'published', 'customer_id': customer?.id}}
                    initialValue={quotation?.id}
                    keys={quotation?.id}
                    row={(d) => {
                      return { value: d.id, label: d.code };
                    }}
                    onSelected={(c) => {
                      setState((prevState) => ({
                        ...prevState,
                        quotation: c,
                      }))
                    }}
                    errors={StateForm?.errors?.quotation_id}
                  />
                </div>

              )}

              <Form.Input
                required
                label="Nama"
                type="text"
                value={name}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    name: e.target.value,
                  }))
                }
                error={StateForm?.errors?.name}
              />
              <div className="mb-3">
                <label className='form-label required'>Pilih Tipe</label>
                <Select
                  isClearable
                  classNamePrefix={
                    StateForm?.errors?.type
                      ? 'is-invalid'
                      : 'select'
                  }
                  placeholder=""
                  value={typeSelected}
                  options={typeOptions}
                  onChange={(e) => {
                    setState((prevState) => ({
                      ...prevState,
                      typeSelected: e,
                    }))
                  }}
                  error={StateForm?.errors?.type}
                />

                {StateForm?.errors?.type ? (
                  <div
                    className="invalid-feedback"
                    style={{ display: 'block' }}
                  >
                    {StateForm?.errors?.type}
                  </div>
                ) : null}
              </div>
              <div className="mb-3">
                <label className='form-label required'>Pilih Invoice Method</label>
                <Select
                  isClearable
                  classNamePrefix={
                    StateForm?.errors?.invoice_method
                      ? 'is-invalid'
                      : 'select'
                  }
                  placeholder=""
                  value={invoiceMethod}
                  options={methodOptions}
                  onChange={(e) => {
                    setState((prevState) => ({
                      ...prevState,
                      invoiceMethod: e,
                    }))
                  }}
                  error={StateForm?.errors?.invoice_method}
                />

                {StateForm?.errors?.invoice_method ? (
                  <div
                    className="invalid-feedback"
                    style={{ display: 'block' }}
                  >
                    {StateForm?.errors?.invoice_method}
                  </div>
                ) : null}
              </div>
              <div className="mb-3">
                <label className='form-label required'>Pilih Ketentuan Pembayaran</label>
                <Select
                  isClearable
                  classNamePrefix={
                    StateForm?.errors?.top
                      ? 'is-invalid'
                      : 'select'
                  }
                  placeholder=""
                  value={termOfPayment}
                  options={topOptions}
                  onChange={(e) => {
                    setState((prevState) => ({
                      ...prevState,
                      termOfPayment: e,
                    }))
                  }}
                  error={StateForm?.errors?.top}
                />

                {StateForm?.errors?.top ? (
                  <div
                    className="invalid-feedback"
                    style={{ display: 'block' }}
                  >
                    {StateForm?.errors?.top}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="col-md-6 px-md-4 px-0">
              <div className="mb-3">
                <label className="form-label required">Bulan Mulai</label>
                <div
                  className={
                    StateForm?.errors?.start_monthly
                      ? 'border border-danger rounded'
                      : ''
                  }
                >
                  <DatePicker
                    selectionMode="month"
                    value={start?.default || null}
                    format="MM/yyyy"
                    onChange={(date) => {
                      $handleStart(date);
                    }}
                    error={StateForm?.errors?.start_monthly}
                  />
                </div>

                {StateForm?.errors?.start_monthly ? (
                  <div className="invalid-feedback" style={{ display: 'block' }}>
                    {StateForm?.errors?.start_monthly}
                  </div>
                ) : null}
              </div>
              <div className="mb-3">
                <label className="form-label required">Bulan Selesai</label>
                <div
                  className={
                    StateForm?.errors?.end_monthly
                      ? 'border border-danger rounded'
                      : ''
                  }
                >
                  <DatePicker
                    selectionMode="month"
                    value={end?.default || null}
                    format="MM/yyyy"
                    onChange={(date) => {
                      $handleEnd(date);
                    }}
                    error={StateForm?.errors?.end_monthly}
                  />
                </div>

                {StateForm?.errors?.end_monthly ? (
                  <div className="invalid-feedback" style={{ display: 'block' }}>
                    {StateForm?.errors?.end_monthly}
                  </div>
                ) : null}
              </div>
              <div className="mb-3">
                <Form.Checkbox
                  onChange={() => {
                    if (!is_pkp) {
                      setState((prevState) => ({
                        ...prevState,
                        is_pkp: true,
                      }));
                    } else {
                      setState((prevState) => ({
                        ...prevState,
                        is_pkp: false,
                      }));
                    }
                  }}
                  iconSize={18}
                  value={is_pkp}
                  label="Pengusaha Kena Pajak"
                />
              </div>

              <Form.Input
                required={is_pkp}
                value={ppn}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    ppn: e.target.valueNumber,
                  }))
                }
                type="number"
                label="PPN"
                error={StateForm?.errors?.ppn}
              />

              <Form.Input
                value={pph}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    pph: e.target.valueNumber,
                  }))
                }
                type="number"
                label="PPH"
              />
            </div>
          </div>
        </div>
        // <div className="mt-3">
        //   <div className="fw-semibold py-2 fs-6">Informasi Product</div>
        //     <div className="py-3">
        //       <Form.Input
        //         required
        //         label="Nama"
        //         type="text"
        //         value={name}
        //         onChange={(e) =>
        //           setState((prevState) => ({
        //             ...prevState,
        //             name: e.target.value,
        //           }))
        //         }
        //         error={StateForm?.errors?.name}
        //       />
        //       <Form.Input
        //         label="Barcode"
        //         type="text"
        //         value={barcode}
        //         onChange={(e) =>
        //           setState((prevState) => ({
        //             ...prevState,
        //             barcode: e.target.value,
        //           }))
        //         }
        //         error={StateForm?.errors?.barcode}
        //       />

        //       <Form.Input
        //         label="Kategori"
        //         required
        //         type="text"
        //         value={category}
        //         onChange={(e) =>
        //           setState((prevState) => ({
        //             ...prevState,
        //             category: e.target.value,
        //           }))
        //         }
        //         error={StateForm?.errors?.category}
        //       />

        //       <Form.Textbox
        //         label="Catatan"
        //         type="text"
        //         value={note}
        //         onChange={(e) =>
        //           setState((prevState) => ({
        //             ...prevState,
        //             note: e.target.value,
        //           }))
        //         }
        //         error={StateForm?.errors?.note}
        //       />
        //     </div>
        // </div>
      )}
    </div>
  );
};
